import React from 'react';
import Header from '../components/layout/header';
import './home.css'
import Footer from '../components/layout/footer';
import Sec11 from '../components/layout/section11';
const Error = () => {
    return ( <><body className='bodyyy'>
    <main>
    <Header />


   <Sec11 />

<Footer />
    </main>
</body>
    </> );
}
 
export default Error;


